import { render, staticRenderFns } from "./StatusCheckPage.vue?vue&type=template&id=afc44cca"
import script from "./StatusCheckPage.vue?vue&type=script&lang=ts"
export * from "./StatusCheckPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports